import { render, staticRenderFns } from "./Teleport.vue?vue&type=template&id=a4c62572&scoped=true&"
import script from "./Teleport.vue?vue&type=script&lang=ts&"
export * from "./Teleport.vue?vue&type=script&lang=ts&"
import style0 from "./Teleport.vue?vue&type=style&index=0&id=a4c62572&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c62572",
  null
  
)

export default component.exports